import { useContext } from "react";

import { AuthenticationContext, IAuthenticationContext } from "./AuthenticationContext";

export const useAuthentication = (): IAuthenticationContext => {
  const context = useContext(AuthenticationContext);

  if (!context) {
    throw new Error("useAuthentication() must be used within a <AuthenticationProvider /> component.");
  }

  return context;
};
